(function(scope){
'use strict';
// Cart page and cart drawer: replace the plain variant photo of every ACME artwork line with the real mockup, drawn
// from the line's _acme_print_snapshot exactly as the product page draws it (AcmePrintLayout.previewBox, the registry
// art and the catalog shirt photo). Display only: checkout, cart properties and the paid pipeline are untouched.
// Ink colour on screen: registry.inkDisplay (e.g. Fire Red shown lighter than its print hex), as on the product page.
// Lines without a snapshot, or with a design/shirt this registry or catalog doesn't know, keep the theme's photo.
function lineMockup(snapshot,registry,catalog,layout,assetBase){
 const design=registry?.designs?.[snapshot?.design];if(!design||!snapshot.source?.bounds)return null;
 const versions=[{...design},...Object.values(design.artworkVariants||{}).map(v=>({...design,...v})),...Object.values(design.artworkByShirt||{}).map(v=>({...design,printMode:undefined,...v}))];
 const art=versions.find(v=>v.productionAssetKey===snapshot.productionAsset);if(!art?.image)return null;
 const garment=[catalog,...(catalog.alternatives||[])].find(g=>g.key===snapshot.garment),color=garment?.colors.find(c=>c.name===snapshot.color);if(!color?.image)return null;
 const photo=garment.printProfile?.photos?.[snapshot.color]||garment.printProfile?.photoDefault,hem=Object.hasOwn(snapshot,'hemOffsetIn');
 const plan={widthIn:snapshot.widthIn,heightIn:snapshot.heightIn,bounds:snapshot.source.bounds,[hem?'hemOffsetIn':'collarOffsetIn']:snapshot[hem?'hemOffsetIn':'collarOffsetIn'],...(snapshot.previewHorizontalOffset?{horizontalOffsetIn:snapshot.previewHorizontalOffset}:{})};
 const box=layout.previewBox({...art,source:snapshot.source},plan,photo);if(!box)return null;
 const fullColor=snapshot.ink==='Full color';if(!fullColor&&!/^#[0-9a-f]{6}$/i.test(snapshot.inkHex||''))return null;
 return {photoUrl:color.image,artUrl:new URL(art.image,assetBase).href,fullColor,inkHex:fullColor?null:(registry.inkDisplay?.[snapshot.ink]||snapshot.inkHex),foil:snapshot.finish==='foil'?String(snapshot.ink):null,box,alt:design.name+' in '+String(snapshot.ink).toLowerCase()+(fullColor?'':' ink')+' on '+snapshot.color};
}
// Foil lines (wave 2): a metallic sheen over the foil's reference colour, as on the product page.
const FOIL_SHEEN={'Silver Foil':'linear-gradient(135deg,#8e8e8e 0%,#f4f4f4 35%,#a9a9a9 55%,#ffffff 70%,#7d7d7d 100%)','Gold Foil':'linear-gradient(135deg,#9a7413 0%,#f7e08a 35%,#b8902a 55%,#fff1b0 70%,#8a6410 100%)'};
function draw(media,m){
 const sig=JSON.stringify(m);if(media.dataset.acmeMockup===sig)return;
 const frame=document.createElement('span'),img=document.createElement('img'),art=document.createElement('span');
 frame.style.cssText='position:relative;display:block;width:100%;aspect-ratio:4/5;background:#fff;overflow:hidden';
 img.src=m.photoUrl+(m.photoUrl.includes('?')?'&':'?')+'width=400';img.alt=m.alt;img.loading='lazy';img.style.cssText='position:absolute;inset:0;width:100%;height:100%;object-fit:contain';
 art.setAttribute('aria-hidden','true');art.style.cssText='position:absolute;pointer-events:none;left:'+m.box.left+'%;top:'+m.box.top+'%;width:'+m.box.width+'%;height:'+m.box.height+'%';
 if(m.fullColor){art.style.backgroundImage='url("'+m.artUrl+'")';art.style.backgroundSize='contain';art.style.backgroundRepeat='no-repeat';art.style.backgroundPosition='center';}
 else{for(const p of ['maskImage','webkitMaskImage'])art.style[p]='url("'+m.artUrl+'")';for(const p of ['maskSize','webkitMaskSize'])art.style[p]='contain';for(const p of ['maskRepeat','webkitMaskRepeat'])art.style[p]='no-repeat';for(const p of ['maskPosition','webkitMaskPosition'])art.style[p]='center';art.style.backgroundColor=m.inkHex;if(m.foil)art.style.backgroundImage=FOIL_SHEEN[m.foil]||FOIL_SHEEN['Silver Foil'];}
 frame.append(img,art);media.replaceChildren(frame);media.style.aspectRatio='4 / 5';media.dataset.acmeMockup=sig;
}
// The theme only renders the photo link when the product has media; the four garment products and the Foil upgrade have
// none (Lawrence: "no place holder images"). Create the same link the theme uses (cart-products.liquid: a.cart-items__media-container
// inside td.cart-items__media, linking to the item) so the mockup has somewhere to draw.
function mediaFor(row,item){
 const existing=row.querySelector('.cart-items__media-container');if(existing)return existing;
 const cell=row.querySelector('.cart-items__media');if(!cell)return null;
 const a=document.createElement('a');a.className='cart-items__media-container';a.href=item.url||'#';a.style.setProperty('--ratio','0.8');a.dataset.acmeCreated='1';
 cell.append(a);return a;
}
// Foil guard (auditor 2026-10-22, two HIGH money defects; Basic plan has no checkout validation): the $4 Foil upgrade line
// must always equal the number of foil shirts of its design. Pure planner, exported for tests: given cart.js and the
// Foil upgrade variant id, return the cart edits that restore that rule. Foil shirts are lines whose snapshot finish is
// 'foil', grouped by their Design property; upgrade lines carry _foil_upgrade_for = that Design.
function foilPlan(cart,foilVariantId){
 const want={},ups={},ops=[];
 for(const i of cart?.items||[]){
  const p=i.properties||{};
  if(typeof p._foil_upgrade_for==='string'){(ups[p._foil_upgrade_for]||=[]).push(i);continue;}
  if(typeof p._acme_print_snapshot!=='string')continue;
  let s;try{s=JSON.parse(p._acme_print_snapshot);}catch{continue;}
  if(s.finish==='foil'&&p.Design)want[p.Design]=(want[p.Design]||0)+Number(i.quantity||0);
 }
 for(const [design,lines] of Object.entries(ups)){const n=want[design]||0;
  lines.forEach((l,k)=>{const q=k===0?n:0;if(Number(l.quantity)!==q)ops.push({type:'change',key:l.key,quantity:q,design});});}
 for(const [design,n] of Object.entries(want))if(n>0&&!ups[design]&&foilVariantId)ops.push({type:'add',id:foilVariantId,quantity:n,design});
 return ops;
}
const FOIL_NOTE='$4 foil fee per foil shirt. It follows the shirt quantity.';
function guardRows(cart){
 // The upgrade row has no stepper or Remove of its own (the guard sets it) and carries a one-line note. It stays where the
 // theme put it: moving it under its shirt took the form's quantity boxes out of the cart's line order (2026-10-30 audit).
 for(const i of cart?.items||[]){
  const d=i.properties?._foil_upgrade_for;if(typeof d!=='string')continue;
  for(const row of document.querySelectorAll('[data-key="'+CSS.escape(i.key)+'"]')){
   const q=row.querySelector('.cart-items__quantity');if(q)q.style.visibility='hidden';
   const det=row.querySelector('.cart-items__details');
   if(det&&!det.querySelector('[data-acme-foil-note]')){const p=document.createElement('p');p.dataset.acmeFoilNote='1';p.textContent=FOIL_NOTE;det.append(p);}
  }
 }
}
const isFoilShirt=i=>{const p=i?.properties,s=p?._acme_print_snapshot;if(typeof s!=='string'||!p.Design)return false;try{return JSON.parse(s).finish==='foil';}catch{return false;}};
const hasFoil=cart=>(cart?.items||[]).some(i=>typeof i.properties?._foil_upgrade_for==='string'||isFoilShirt(i));
// The cart form posts updates[] by position. Pure, exported for tests: given the form's rows ([{key,value}] in form order)
// and the cart they belong to, return the values to post, each Foil upgrade entry set to the sum of its design's foil
// shirt entries in the same form (0 for a second upgrade line of one design, as foilPlan).
function foilUpdates(rows,cart){
 const byKey={},want={},seen={};for(const i of cart?.items||[])byKey[i.key]=i;
 for(const r of rows){const i=byKey[r.key];if(isFoilShirt(i))want[i.properties.Design]=(want[i.properties.Design]||0)+(parseInt(r.value,10)||0);}
 return rows.map(r=>{const d=byKey[r.key]?.properties?._foil_upgrade_for;if(typeof d!=='string')return String(r.value);const v=seen[d]?0:(want[d]||0);seen[d]=1;return String(v);});
}
function isCartForm(f){
 if(!f||f.tagName!=='FORM')return false;if(f.id==='cart-form')return true;
 try{return /\/cart\/?$/.test(new URL(f.getAttribute('action')||'',location.href).pathname);}catch{return false;}
}
const formRows=f=>[...f.elements].filter(el=>el.name==='updates[]'&&!el.disabled).map(el=>({el,key:el.closest('[data-key]')?.dataset.key||'',value:el.value}));
const FOIL_FAIL="We couldn't update the foil fee in your cart. Refresh the page and try again.";
function cartError(near){
 const host=near?.closest?.('.cart__ctas,.cart-actions,.cart__summary-totals')||near?.parentElement;if(!host)return;
 let p=host.querySelector('[data-acme-foil-error]');
 if(!p){p=document.createElement('p');p.setAttribute('role','alert');p.dataset.acmeFoilError='1';host.prepend(p);}
 p.textContent=FOIL_FAIL;
}
function start(me){
 const registryUrl=me?.dataset.acmeRegistry,catalogUrl=me?.dataset.acmeCatalog,layout=scope.AcmePrintLayout;
 if(!registryUrl||!catalogUrl||!layout)return;
 let data=null,busy=false,again=false,timer=null,guardWrites=0,last=null,going=false;  // last: the cart as last read
 const root=scope.Shopify?.routes?.root||'/';
 const getCart=async()=>last=await (await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'})).json();
 const post=(path,body)=>fetch(root+path,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
 const loadData=async()=>data||=await Promise.all([registryUrl,catalogUrl].map(u=>fetch(u).then(r=>r.json())));
 const foilVariant=()=>Number(String(data?.[0]?.foilUpgrade?.variantId||'').split('/').pop())||null;
 async function applyOps(ops){
  for(const op of ops){
   if(op.type==='change')await post('cart/change.js',{id:op.key,quantity:op.quantity});
   else await post('cart/add.js',{items:[{id:op.id,quantity:op.quantity,properties:{_foil_upgrade_for:op.design}}]});
  }
 }
 async function apply(){
  if(busy){again=true;return;}busy=true;
  try{
   const rows=document.querySelectorAll('[data-key]');if(!rows.length)return;
   let cart=await getCart();
   const foil=hasFoil(cart);
   const lines=(cart.items||[]).filter(i=>typeof i.properties?._acme_print_snapshot==='string');if(!lines.length&&!foil)return;
   await loadData();
   if(foil){
    const ops=foilPlan(cart,foilVariant());
    if(ops.length&&guardWrites<6){  // cap per page load: if the store keeps refusing, stop and leave it to the order check
     guardWrites++;
     await applyOps(ops);
     cart=await getCart();
     // Let the theme redraw the cart page/drawer and the cart count from the corrected cart.
     const ev=new Event('cart:update',{bubbles:true});ev.detail={resource:cart,sourceId:'acme-foil-guard',data:{source:'acme-foil-guard',itemCount:cart.item_count}};document.dispatchEvent(ev);
    }
    guardRows(cart);
   }
   const drawn=[];
   for(const item of lines){
    let snapshot;try{snapshot=JSON.parse(item.properties._acme_print_snapshot);}catch{continue;}
    const m=lineMockup(snapshot,data[0],data[1],layout,new URL(registryUrl,location.href).href);if(!m)continue;
    drawn.push({item,snapshot,m});
    for(const row of document.querySelectorAll('[data-key="'+CSS.escape(item.key)+'"]')){const media=mediaFor(row,item);if(media)draw(media,m);}
   }
   // Foil upgrade line ($4 add-on): show the shirt it upgrades, when exactly one foil line in the cart has that design.
   for(const item of (cart.items||[]).filter(i=>typeof i.properties?._foil_upgrade_for==='string')){
    const match=drawn.filter(d=>d.snapshot.finish==='foil'&&d.item.properties?.Design===item.properties._foil_upgrade_for);
    if(match.length!==1)continue;
    for(const row of document.querySelectorAll('[data-key="'+CSS.escape(item.key)+'"]')){const media=mediaFor(row,item);if(media)draw(media,match[0].m);}
   }
  }catch(e){/* display only: on any failure the theme's own photo stays */}
  finally{busy=false;if(again){again=false;schedule();}}
 }
 function schedule(){clearTimeout(timer);timer=setTimeout(apply,120);}
 // The theme re-renders cart rows (quantity changes, drawer opening); redraw after it does.
 new MutationObserver(muts=>{if(muts.some(m=>[...m.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-key],.cart-items__media-container img')||n.querySelector?.('[data-key]')))))schedule();}).observe(document.body,{childList:true,subtree:true});
 // Checkout (the Basic plan has no checkout validation): the cart must first hold what the form shows, every Foil upgrade
 // equal to its foil shirts. While the cart holds a name & number line, acme-name-number.js runs this wait for its own fee
 // and then saves the form's boxes, which the input handler below keeps right for foil, so this one stands aside.
 const nnWaits=()=>!!scope.AcmeNameNumber&&(last===null||(last.items||[]).some(i=>typeof i.properties?._nn_for==='string'&&i.properties._nn_for));
 const mayHaveFoil=()=>last===null||hasFoil(last);
 async function goCheckout(href,form,trigger){
  if(going)return;going=true;if(trigger)trigger.disabled=true;
  try{
   let cart=await getCart();
   if(hasFoil(cart)){
    await loadData();
    if(form){
     const rows=formRows(form),out=foilUpdates(rows,cart),updates={},note=form.querySelector('textarea[name="note"]')?.value;
     rows.forEach((r,k)=>{const n=parseInt(out[k],10);if(r.key&&isFinite(n)&&n>=0)updates[r.key]=n;});
     if(Object.keys(updates).length||note!=null){await post('cart/update.js',{updates,...(note!=null?{note}:{})});cart=await getCart();}
    }
    const ops=foilPlan(cart,foilVariant());if(ops.length){await applyOps(ops);cart=await getCart();}
    if(foilPlan(cart,foilVariant()).length)throw new Error('foil fee not in step');
   }
   location.assign(href);return;  // stays busy while the browser leaves
  }catch(e){
   going=false;if(trigger)trigger.disabled=false;
   if(last&&hasFoil(last))cartError(trigger||form);else location.assign(href);  // unknown or no foil: as before this guard
  }
 }
 // Window capture listeners run before the theme's own, which it delegates from capture listeners on document.
 window.addEventListener('submit',e=>{
  const f=e.target;if(!isCartForm(f)||e.submitter?.name!=='checkout'||!mayHaveFoil()||nnWaits())return;
  e.preventDefault();e.stopImmediatePropagation();goCheckout(root+'checkout',f,e.submitter);
 },true);
 window.addEventListener('click',e=>{
  if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
  const a=e.target?.closest?.('a[href]');if(!a||!mayHaveFoil()||nnWaits())return;
  let u;try{u=new URL(a.href,location.href);}catch{return;}
  if(u.origin!==location.origin||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkouts?(?:\/|$)/i.test(u.pathname))return;
  e.preventDefault();e.stopImmediatePropagation();
  const f=a.closest('form')||document.querySelector('form#cart-form');goCheckout(u.href,isCartForm(f)?f:null,null);
 },true);
 // Enter in a cart quantity box updates the cart (as leaving the box does) instead of submitting the form to checkout.
 window.addEventListener('keydown',e=>{
  if(e.key!=='Enter'||e.isComposing||!hasFoil(last))return;
  const t=e.target;if(t?.tagName!=='INPUT'||!(t.name==='updates[]'||t.type==='number')||!isCartForm(t.form))return;
  e.preventDefault();t.blur();t.focus();
 },true);
 // Whatever submits the cart form, a Foil upgrade line posts its shirts' quantities, never a stale value.
 window.addEventListener('formdata',e=>{
  const f=e.target;if(!isCartForm(f)||!hasFoil(last)||!e.formData)return;
  const values=e.formData.getAll('updates[]'),rows=formRows(f);if(values.length!==rows.length)return;
  rows.forEach((r,k)=>{r.value=values[k];});
  const out=foilUpdates(rows,last);e.formData.delete('updates[]');out.forEach(v=>e.formData.append('updates[]',v));
 },true);
 // A Foil upgrade's hidden quantity box follows its shirts' boxes as the shopper types.
 window.addEventListener('input',e=>{
  const t=e.target;if(t?.name!=='updates[]'||!isCartForm(t.form)||!hasFoil(last))return;
  const rows=formRows(t.form),out=foilUpdates(rows,last);
  rows.forEach((r,k)=>{if(r.el!==t&&String(r.el.value)!==out[k])r.el.value=out[k];});
 },true);
 schedule();
}
if(typeof module!=='undefined'&&module.exports)module.exports={lineMockup,foilPlan,foilUpdates};
else{const me=document.currentScript;if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>start(me),{once:true});else start(me);}
})(typeof window!=='undefined'?window:globalThis);
